import { useEffect } from 'react'

import { useManagementSearchUnits } from '@apps-common/apis/management/unit'
import { useManagementSearchUnitsCount } from '@apps-common/apis/management/unit/search-units-count'
import { buildTableKeys } from '@apps-common/apps/portal/pages/units/components/management'
import { RootHeaderButtons } from '@apps-common/components/common'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { ManagementUnitsFilterExportModal } from '@apps-common/components/modals/ManagementUnitsFilterExportModal'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { commonIcons } from '@apps-common/config/icons'
import { snakeToSentence } from '@apps-common/helpers/snakeCaseToSentence'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { usePortalFirebaseUser } from '@apps-common/hooks/usePortalFirebaseUser'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { useManagementUnitsFilterStore } from '@apps-common/stores'
import { ManagementUnitsHeader } from '../ManagementUnitsHeader'

export const ManagementUnitsTableView = () => {
  const user = usePortalFirebaseUser()
  const navigation = useNavigation()
  const { navigateForward } = navigation
  const filter = useManagementUnitsFilterStore()

  const {
    isLoading: countIsLoading,
    // isFetching: countIsFething,
    // isRefetching: countIsRefetching,
    isError: countIsError,
    data: countData,
    refetch: countRefetch
  } = useManagementSearchUnitsCount({
    model: filter
  })

  const {
    isLoading: unitsLoading,
    // isFetching: unitsFetching,
    // isRefetching: unitsRefetching,
    isError: unitsError,
    data: units,
    refetch: unitsRefetch
  } = useManagementSearchUnits({
    model: filter
  })

  useEffect(() => {
    const element = document.getElementById('management-units-table-container')

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [unitsLoading])

  const icons: any = <RootHeaderButtons />
  const countLoading = countIsLoading || countIsError
  const loading = unitsLoading || unitsError || countLoading

  return (
    <>
      <ManagementUnitsHeader
        icons={icons}
        leftComponent={
          <PageResultsCount loading={countLoading} count={countData} extraText={snakeToSentence(filter.status)}>
            |&nbsp;
            <ModalButton
              classes='jost underline text-text !px-0 !py-0 rounded-full flex items-center justify-start gap-[5px]'
              component={ManagementUnitsFilterExportModal}
              disabled={false}
              enterAnimation={modalSlideUpEnterAnimation}
              leaveAnimation={modalSlideUpLeaveAnimation}
            >
              Export
              <commonIcons.export />
            </ModalButton>
          </PageResultsCount>
        }
        rightComponent={<PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />}
        loading={countLoading}
        navigateForward={navigateForward}
        searchCount={countData?.resultCount || -1}
      />
      <LayoutContainer id='management-units-table-container'>
        <LayoutPadding topPadding='pt-[20px] md:pt-[20px]'>
          <Table
            loading={loading}
            loadingSkeletonHeight='!leading-[36px]'
            placeholderSkeletonHeight='!leading-[36px]'
            pagination={{
              loading: countLoading,
              count: countData?.resultCount,
              skip: filter.skip,
              take: filter.take,
              onSkipChanged: (value) => filter.setSkip(value),
              onTakeChanged: (value) => filter.setTake(value)
            }}
            keysId={`${filter.status}-${user?.isMonitoringCentre}`}
            keys={buildTableKeys(navigation, filter)}
            data={units}
            onSkipChanged={(value) => filter.setSkip(value)}
            onTakeChanged={(value) => filter.setTake(value)}
          />
        </LayoutPadding>
      </LayoutContainer>
    </>
  )
}
